import axios from "@/utils/axios";
import type {
  ConfirmUploadResponse,
  RequestUploadUrlPayload,
  RequestUploadUrlResponse,
  UploadRequestMetadata,
  UploadStatusResponse,
} from "./types";

/** Lets a caller opt out of the global 401/403 redirects (see `utils/axios.ts`). */
export type UploadRequestConfig = { metadata?: UploadRequestMetadata };

export const requestUploadUrl = async (
  payload: RequestUploadUrlPayload,
  config: UploadRequestConfig = {},
): Promise<RequestUploadUrlResponse> => {
  const response = await axios.post<{ data: RequestUploadUrlResponse }>(
    "admin/v1/uploads/request-url",
    payload,
    {
      ...config,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  );
  return response.data.data;
};

export const confirmUpload = async (
  id: string,
  config: UploadRequestConfig = {},
): Promise<ConfirmUploadResponse> => {
  const response = await axios.post<{ data: ConfirmUploadResponse }>(
    `admin/v1/uploads/${id}/confirm`,
    undefined,
    { ...config, headers: { Accept: "application/json" } },
  );
  return response.data.data;
};

export const getUploadStatus = async (
  id: string,
): Promise<UploadStatusResponse> => {
  const response = await axios.get<{ data: UploadStatusResponse }>(
    `admin/v1/uploads/${id}/status`,
    { headers: { Accept: "application/json" } },
  );
  return response.data.data;
};

export const cancelUpload = async (
  id: string,
  config: UploadRequestConfig = {},
): Promise<void> => {
  try {
    await axios.delete(`admin/v1/uploads/${id}`, {
      ...config,
      headers: { Accept: "application/json" },
    });
  } catch (err) {
    // Idempotent: a 404 means it's already gone, which is fine.
    const status = (err as { response?: { status?: number } })?.response
      ?.status;
    if (status !== 404) throw err;
  }
};
